export const EMPTY_CONTENT_PAGE = {
  title: '',
  content: '',
  heroBackgroundImage: { url: '' },
};
